module.exports = __webpack_public_path__ + "media/images/lp_v6_check2-3c758f5807bb37aeeb1dd47f5356c8d2.webp";